import { MCheckBox } from "../M_CheckBox"

const defaultStyle = { position: 'fixed', overflow: 'hidden', height: '100%', width: '100%', zIndex: '5000000', backgroundColor: 'var(--color-grey-light)', opacity: '0.7' }
export const loadingStyle = { ...defaultStyle, height: '100vh' }
const hideStyle = () => { return { ...defaultStyle, display: 'none' } }
const mainStyle = (adjustingTableMedia2) => { return adjustingTableMedia2 ? { ...loadingStyle, top: '50px' } : { ...loadingStyle, top: '0px' } }

export function loadingStylesFunc(loading, adjustingTableMedia2) { return loading ? mainStyle(adjustingTableMedia2) : hideStyle() }
export function filterIconBackgroundColor(color) { return color || "var(--color-black)" }

export function viewDefaultButtonBorderColor(selectedView, color) { return selectedView === 'Default' ? color || "var(--color-black)" : 'var(--color-grey-light)' }
export function viewDefaultButtonBackgroundColor(selectedView, color) { return selectedView === 'Default' ? color || "var(--color-black)" : 'transparent' }
export function viewDefaultButtonLabelColor(selectedView) { return selectedView === 'Default' ? "var(--color-white)" : "var(--color-black)" }

export function viewFilterButtonBorderColor(col, selectedView, color) { return selectedView === col ? color || "var(--color-black)" : 'var(--color-grey-light)' }
export function viewFilterButtonBackgroundColor(col, selectedView, color) { return selectedView === col ? color || "var(--color-black)" : 'transparent' }
export function viewFilterButtonLabelColor(col, selectedView) { return selectedView === col ? "var(--color-white)" : "var(--color-black)" }

export function sortFields(field, orderFields, groupField) {
    if (orderFields) {
        if (field === 'sortOrder') return 1
        if (field === 'sortField') return groupField
    }
    return null
}

export function crudInPopUp(metaType) {
    const checkSizeOptions = metaType.filter(obj => !obj?.metaIsEdit)
    return checkSizeOptions.length <= 5

}

export function columnOrderHeaderIcon(iconForm, col) {
    if (iconForm === 'asc') return <i id='columnTable' title={col.Header} className="pi pi-sort-amount-down "></i>
    if (iconForm === 'desc') return <i id='columnTable' title={col.Header} className="pi pi-sort-amount-up "></i>
    return <i id='columnTable' title={col.Header} className="pi pi-sort-alt"></i>
}

export function headerLabelFunc(label, maxWidth, t) {
    if (maxWidth) return t(label)
    return ""
}

export function validationHeaderButtonsFunc(operation, removeItem, permissions) {
    switch (operation) {
        case 'Create':
            return permissions.includes('Create') && !removeItem.includes('Create')
        case 'Edit':
            return permissions.includes('Update') && !removeItem.includes('Update')
        case 'Delete':
            return permissions.includes('Delete') && !removeItem.includes('Delete')
        case 'Copy':
            return permissions.includes('Create') && (!removeItem.includes('Create') && !removeItem.includes('Copy'))
        default: break
    }
}

export function sortAuditData(auditData) {
    const newArray = auditData?.toSorted((a, b) => Date.parse(a?.CreationDate) - Date.parse(b?.CreationDate))
    return newArray || []
}

export function auditActionColor(obj) {
    if (obj.Action === 'Create') return 'var(--color-green)'
    if (obj.Action === 'Update') return 'var(--color-yellow)'
    return 'var(--color-black)'
}

export function exportTemplate(metaType, XLSX, entity) {
    const tempObj = {}
    metaType.forEach(obj => {
        if (obj.metaType === "byte[]" || obj.metaType === "guid") return
        if (obj.metaIsEdit === false) {
            tempObj[obj.metaDisplay] = ''
        }
    })
    const tempArray = [tempObj]
    let wb = XLSX.utils.book_new(),
        ws = XLSX.utils.json_to_sheet(tempArray)
    XLSX.utils.book_append_sheet(wb, ws, entity)
    XLSX.writeFile(wb, `${entity}_Template.xlsx`)
}

export function onlyVisibleItems(lineArray, selectedColumns) {
    let dict = new Map()
    const objectArray = []
    lineArray.forEach(element => {
        const newItem = visibleItemsSelectColumns(element, dict, selectedColumns)
        dict = new Map(newItem[1])
        if (newItem) objectArray.push(newItem[0])
    })
    return objectArray
}

function visibleItemsSelectColumns(element, dict, selectedColumns) {
    let tempBol = false
    Object.entries(element).forEach(keyValue => {
        tempBol = false
        selectedColumns.forEach(header => {
            if (header.Name === keyValue[0]) tempBol = true
        })
        if (tempBol) dict.set(keyValue[0], keyValue[1])
    })
    // objectArray.push(Object.fromEntries(dict))
    return [Object.fromEntries(dict), dict]
}


export function extraButtonFunction(data, func, need, toastMessages, t, selectedRows, value) {
    const tempNeed = need !== null ? need : true
    if (data === undefined && tempNeed) {
        toastMessages('error', '', t("SelectedLine"))
        return
    }
    if (value) {
        func(selectedRows)
    } else {
        func(data)
    }
}

export function columnInfoHeaderIcon(infoElement, col) {
    if (infoElement?.get(col.Header)) {
        return (
            <div className="tooltip">
                <span className="tooltiptext">
                    <ul style={{ listStyle: 'none', margin: '0', padding: '0' }}>
                        {infoElement.get(col.Header).map((info, index) => (
                            <li key={info || index} style={{ marginBottom: '10px' }}>
                                {info}
                            </li>
                        ))}
                    </ul>
                </span>
            </div>)
    }
}

export function imageBodyTemplate(rowData, field) {
    return <div
        style={{ width: '50px', display: 'flex', fontWeight: 'bolder', color: 'white', justifyContent: 'center', textAlign: 'center', alignItems: 'center', borderRadius: '6px', padding: '2px 10px', fontSize: '0.8rem' }}>
        <img width={'25px'} src={rowData[field] ? `data:image/jpeg;base64,${rowData[field]}` : '/images/noImage.png'} alt={field} />
    </div>
}

export function onlyVisibleItemsNoImages(lineArray, selectedColumns) {
    let dict = new Map()
    const objectArray = []
    lineArray.forEach(element => {
        const newItem = visibleItemsNoImagesSelectedColumn(element, dict, selectedColumns)
        dict = new Map(newItem[1])
        if (newItem) objectArray.push(newItem[0])
    })
    return objectArray
}

function visibleItemsNoImagesSelectedColumn(element, dict, selectedColumns) {
    let tempBol = false
    Object.entries(element).forEach(keyValue => {
        tempBol = false
        selectedColumns.forEach(header => {
            if (header.Type === "byte[]" && header.Name === keyValue[0]) {
                dict.set(keyValue[0], '')
                return
            }
            if (header.Name === keyValue[0]) tempBol = true
        })
        if (tempBol) dict.set(keyValue[0], keyValue[1])
    })
    return [Object.fromEntries(dict), dict]
}

export function isColumnChecked(data, selectedColumns) {
    return !!selectedColumns.find((element) => element.name === data)
}


export function getSeverity(data, column, colorOptions) {
    const tempArray = colorOptions?.get(column) ? colorOptions?.get(column) : []
    const tempColor = tempArray.filter(obj => obj.value === data)
    if (tempColor.length > 0) {
        return tempColor[0].severity
    } else {
        return '#000000'
    }
}

export function verifiedBodyTemplate(rowData, field) {
    return (
        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <MCheckBox disabled checked={rowData[field]} noPadding />
        </div>
    )
}

export function worksheetSelectColumns(workbook, worksheet, key, index, selectedColumns, value) {
    if (selectedColumns.some(header => header.Type === "byte[]" && header.Name === key)) {
        const imageId = workbook.addImage({
            base64: `data:image/jpeg;base64,${value}`, // Assuming the value is a base64-encoded image
            extension: 'jpeg', // Change the extension according to your image format
        })
        worksheet.properties.defaultRowHeight = 40
        worksheet.addImage(imageId, {
            tl: { col: selectedColumns.findIndex(header => header.Name === key), row: index + 1 },
            ext: { width: 50, height: 50 } // Adjust width and height as needed
        })
    }
    return workbook
}

export function getColumnObj(header, columns) {
    const tempArray = columns.filter(obj => obj.Header === header)
    return tempArray[0]
}

export function sessionStorageMachine(id, key, value, stopSaveRows) {
    // eslint-disable-next-line
    if (value instanceof Map) {
        // eslint-disable-next-line
        return { key: `${key}`, value: (Array.from(value)) }
    }
    // eslint-disable-next-line
    if (!(stopSaveRows && key === 'rows')) {
        return { key: `${key}`, value: value }
    }
    return null
}


export function selectedIncomingValue(data, value, valueIdField, selectedRows, setSelectedRows) {
    if (value) {
        if (Array.isArray(value)) {
            const tempArray = []
            const newTempArray = []

            //* GET THE REAL OBJECTS FROM THE VALUE ARRAY 
            value.forEach(objValue => {
                if (valueIdField) {
                    const temp = data.Items.filter(obj => obj[valueIdField] === objValue[valueIdField])
                    if (temp.length) {
                        tempArray.push(temp[0])
                    }
                } else {
                    const temp = data.Items.filter(obj => obj?.Id === objValue?.Id)
                    if (temp.length) {
                        tempArray.push(temp[0])
                    }
                }
            })

            if (selectedRows.length) {
                let newTemp = []

                selectedRows.forEach(obj => {
                    if (!tempArray.find(tempObj => tempObj.Id === obj.Id)) {
                        newTemp.push(obj)
                    }
                })
                newTemp.push(...tempArray)
                newTempArray.push(...newTemp)

            } else {
                newTempArray.push(...tempArray)
            }
            setSelectedRows([...newTempArray])
        } else {
            //* GET THE OBJECT VALUE 
            if (valueIdField && value[valueIdField]) {
                const tempArray = data.Items.filter(obj => obj[valueIdField] === value[valueIdField])
                setSelectedRows(tempArray)
                return
            }
            if (value?.Id) {
                const tempArray = data.Items.filter(obj => obj?.Id === value?.Id)
                setSelectedRows(tempArray)
                return
            }

        }
    }
}

export function deRetardationString(data) {
    return data.replace(/([A-Z])/g, ' $1').trim();
}

export function getType(input) {
    if (input === 'true' || input === 'false') {
        return 'boolean';
    } else if (/^-?\d+$/.test(input)) {
        return 'int32';
    } else {
        return 'string';
    }
}

export function getValue(input) {
    if (input === 'true') {
        return true;
    } else if (input === 'false') {
        return false;
    } else if (/^-?\d+$/.test(input)) {
        return parseInt(input);
    } else if (/^-?\d*\.\d+$/.test(input)) {
        return parseFloat(input);
    } else {
        return input;
    }
}


export function getColumnName(tempArray, metaType) { return metaType.filter(meta => meta.metaName === tempArray[0]) }


export function statusBodyTemplate(rowData, field, colorOptions, hideDefaultColor, t) {
    const colorBody = getSeverity(rowData[field], field, colorOptions)
    if (hideDefaultColor && colorBody === '#000000') {
        return <div
            style={{ display: 'flex', fontWeight: 'bolder', justifyContent: 'center', textAlign: 'center', alignItems: 'center', borderRadius: '6px', padding: '3px 10px', fontSize: '0.8rem', }}>
            {t(rowData[field])}
        </div>
    }
    return <div
        style={{ display: 'flex', fontWeight: 'bolder', color: 'white', justifyContent: 'center', textAlign: 'center', alignItems: 'center', borderRadius: '6px', padding: '3px 10px', fontSize: '0.8rem', backgroundColor: colorBody }}>
        {t(rowData[field])}
    </div>
}